import angular from 'angular';
import uiRouter from 'angular-ui-router';
import modal from 'angular-ui-bootstrap/src/modal';
import timesheetReportComponent from './timesheet-report.component';
import datepickerPopup from 'angular-ui-bootstrap/src/datepickerPopup'

let timesheetReportModule = angular.module('timesheetreport', [
  uiRouter,
  modal,
  datepickerPopup
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";
  $urlRouterProvider.otherwise('/');

  $stateProvider.state('timesheetreport', {
    parent: 'app',
    url: '/admin/reports/timesheets',
    data: {
      pageHeader: true,
      pageTitle: 'Employee Timesheets',
      pageDesc: '',
      breadcrumbLink: 'admin.reports',
      breadcrumbText: 'View All Reports'
    },
    template: '<timesheetreport></timesheetreport>'
  });

})

.component('timesheetreport', timesheetReportComponent);

export default timesheetReportModule;



// WEBPACK FOOTER //
// ./client/pages/admin/reports/canned-reports/timesheet-report/timesheet-report.js